import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=d9529d34&scoped=true"
import script from "./CalendarLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarLegend.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CalendarLegend.vue?vue&type=style&index=0&id=d9529d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9529d34",
  null
  
)

export default component.exports